export const changeApnFormInitialState = {
    apnType: "",
    apnName: "",
    vrfName: ""
}

export const mapSelectValues = (changeApnState) => {
    return {
        condivisoApnNames: changeApnState.condivisoApnNames,
        condivisoVrfNames: changeApnState.condivisoVrfNames,
        dedicatoApnNames: changeApnState.dedicatoApnNames,
        sicurezzaCentralizzataApnNames: changeApnState.sicurezzaCentralizzataApnNames
    }
}
